import * as React from 'react';
import { clsx } from 'clsx';
import * as style from './StickyBottomLayout.css';

interface IStickyBottomLayoutProps {
  isShown: boolean;
}

export const StickyBottomLayout: React.FC<React.PropsWithChildren<IStickyBottomLayoutProps>> = ({
  children,
  isShown,
}) => {
  return <div className={clsx(style['container'], isShown && style['container--shown'])}>{children}</div>;
};
